export default class LinsSummary {
    created() {
        this.$sumColumns = {}
    }

    column(name) {
        if (!this.$sumColumns) {
            this.$sumColumns = {}
        }

        if (!this.$sumColumns[name]) {
            this.$sumColumns[name] = {}
        }
        return this.$sumColumns[name]
    }

    clearValues() {
        this.$sumColumns = {}
    }

    addValue(col, key, value, decimal) {
        this.column(col)[String(key)] = value
        this.column(col + 'decimal').decimal = decimal
    }

    delValue(col, key) {
        delete this.column(col)[String(key)]
    }

    sumColumn(name) {
        let total = 0
        let decimal = this.column(name + 'decimal').decimal === -1 ? 0 : this.column(name + 'decimal').decimal
        for (let item in this.column(name)) {
            total += parseFloat(this.column(name)[item])
        }
        return total.toFixed(decimal)
    }
}
